import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 2;
const NotificationMain = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};

export default NotificationMain;
